import { all } from 'redux-saga/effects';
import { mediaNodesRequestWatchSaga, setMediaClusterRequestSaga, mediaClusterSettingsSaga } from './media-cluster/saga';
import { externalNotificationsRequestWatchSaga } from './notifications/saga';
import {
  connectorsRequestWatchSaga,
  createConnectorRequestWatchSaga,
  editConnectorRequestWatchSaga,
} from './connectors/saga';

function* systemWatchSaga() {
  yield all([
    mediaNodesRequestWatchSaga(),
    externalNotificationsRequestWatchSaga(),
    connectorsRequestWatchSaga(),
    createConnectorRequestWatchSaga(),
    editConnectorRequestWatchSaga(),
    setMediaClusterRequestSaga(),
    mediaClusterSettingsSaga(),
  ]);
}

export default systemWatchSaga;
